import { formatters } from 'common';
export const getXAxisLabel = (time) => {
    return formatters.getDate(new Date(time * 1000), 'MMM yy', true);
};
export const getLeftYAxisLabel = (value, suffix, round = true) => {
    const label = formatters.getAmount(value, {
        average: true,
        decimals: round ? 2 : undefined,
    });
    return `${label} ${suffix}`;
};
export const getLeftYAxisOptions = (options, color, suffix) => {
    return Object.assign(Object.assign({}, options), { color, priceScaleId: 'left', priceFormat: {
            type: 'custom',
            formatter: (v) => {
                /**
                 * Note:
                 *
                 * There are 2 reasons the Y axis can show a negative vale on its label:
                 *
                 * Reason 1:
                 * Say we have value on the Y axis from 0 to 100,
                 * on the actual datapoints and this what we plot. But we also plot
                 * the steps based on growith which can be outside of the datapoint.
                 * Meaning, we may have invested only 90, but the step growth of that can be 120, which
                 * suddenly is out of bounds for the chart coz the chart is only aware of the datapoinmts
                 * that is given to it, and not of the extra lines we draw from X to Y locations based on steps.
                 * In order to then scale all drawn lines into the chart pane, we use
                 * `autoscaleInfoProvider` (docs: https://tradingview.github.io/lightweight-charts/docs/4.2/api/interfaces/PriceScaleMargins) -
                 * also see  - `maanger.ts` to understand how the mix and max of this is calculated
                 * on the fly for when data is set. This is crucial we cannot let go of this code.
                 * More docs:
                 * -
                 *
                 * Reason 2:
                 * Now because we scale the chart to fit all the points in the graph within the view pane,
                 * in effect it is like a zoom that is applied to the chart, which means the library
                 * is going to draw what it feels is needed to plot in the Y axis in terms of the label.
                 * And the library comes with some default `scaleMargins` (docs:https://tradingview.github.io/lightweight-charts/docs/4.2/api/interfaces/PriceScaleMargins)
                 * which then ends up plotting negative axis valueson the Y axis.
                 *
                 * The solution:
                 * This is a price graph or funds which theoretically should not go negative.
                 * So we work our way around using some formatting to understand expoential numbers and plotting them at a minimum of 0.
                 * THis allows us to hijack from default formatting in the library for exponential negative very low numbers
                 * as we all not rely fully on our formatters for really small negative numbers
                 * Hence the 2 paths for negative or normal plot Y axis label
                 */
                const isNegative = Math.sign(v) === -1;
                if (isNegative) {
                    /**
                     * Note:
                     *
                     * More times than not this is a very small exponential number, so skipping the is exponent check
                     * Eg: -2.0816681711721685e-17
                     *
                     * The math below simply take first 4 fraction digits into account and interprets the number,
                     * And if that number is really small and or 0, we convert it to a non negative number
                     */
                    const curatedValue = Number(v.toFixed(4));
                    if (curatedValue === 0) {
                        return getLeftYAxisLabel(0, suffix);
                    }
                    /**
                     * Note:
                     *
                     * We should never render a negative Y axis, so never adding a label is good enough here
                     */
                    return '';
                }
                return getLeftYAxisLabel(v, suffix);
            },
        } });
};
export const getRightYAxisLabel = (value, round = true) => {
    return formatters.getBaseCurrency(value, {
        average: round,
        decimals: 2,
    });
};
export const getRightYAxisOptions = (options, color) => {
    return Object.assign(Object.assign({}, options), { color, priceScaleId: 'right', priceFormat: {
            type: 'custom',
            formatter: getRightYAxisLabel,
        } });
};
